import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    paperRoot: {
      marginTop: 32,
      paddingBottom: theme.spacing(2),
      marginRight: 0,
    },
    gridHeader: {
      padding: theme.spacing(2),
    },
    gridContent: {
      padding: theme.spacing(2),
      paddingTop: 0,
    },
    resumeContainer: {
      display: 'flex',
      background: '#ddd9',
      padding: '10px 15px !important',
      borderRadius: 7,
      margin: theme.spacing(1, 1, 1, 1),
    },
    primaryBox1: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
    primaryBox2: {
      color: '#666',
      fontWeight: 'bold',
    },
    secondaryBox: {
      marginTop: -5,
      color: '#777',
    },
    marginRight: {
      marginRight: theme.spacing(1.5),
    },
    search: {
      maxWidth: '100% !important',
    },
    contentFilter: {
      '& div': {
        maxWidth: '100% !important',
      },
    },
    addButton: {
      background: '#0094FF',
      borderRadius: 12,
      color: '#fff',
      minHeight: 40,
      padding: '0px 16px',
      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
    resume: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 70,
      height: 42,
      marginRight: 5,
      padding: 7,
      border: '1px solid #14171A',
      borderRadius: 10,
    },
    contentImage: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 16,
      maxHeight: 16,
      height: '100%',
      marginRight: 5,
    },
    dividerVertical: {
      '&:fist-child': {
        background: '#fff',
      },
      background: '#14171A',
      marginRight: 8,
      marginTop: 1,
    },
    subTiltle: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 700,
      fontSize: 8,
      color: ' #14171A',
      lineHeight: 1,
    },
    value: {
      fontSize: 12,
      color: ' #14171A',
      lineHeight: 1,
    },
    contentTotalEntry: {
      display: 'grid',
      marginRight: 8,
    },
  }),
);

export default useStyles;
